export default `
  <div class="wb-doc-page">
    <div class="doc-text doc-pt16">盈宝社区是一个获取、分享及传播信息的平台，为向所有用户提供更优质的服务，为维护社区的健康发展以及保障用户合法权益，盈宝社区根据现行法律法规制定本规定。</div>

    <div class="doc-main-title">一、言论规则</div>

    <div class="doc-text doc-font-bold">1、禁止发布违反法律法规和相关政策的内容。包括但不限于以下内容：</div>

    <div class="doc-text">1）反对宪法所规定的基本原则；</div>
    <div class="doc-text">2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一，主权和领土完整；</div>
    <div class="doc-text">3）损害国家荣誉和利益；</div>
    <div class="doc-text">4）煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯；</div>
    <div class="doc-text">5）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉；</div>
    <div class="doc-text">6）宣扬恐怖主义、极端主义或煽动实施恐怖活动、极端主义活动；</div>
    <div class="doc-text">7）破坏国家宗教政策，宣扬邪教和封建迷信；</div>
    <div class="doc-text">8）散布谣言。扰乱经济秩序和社会秩序；</div>
    <div class="doc-text">9）散布淫秽、色情、赌博、暴力、凶杀、毒品、恐怖或教唆犯罪；</div>
    <div class="doc-text">10）侮辱或诽谤他人，侵害他人名誉、隐私和其他合法权益；</div>
    <div class="doc-text">11）以营利、获利为目的，违规发布第三方理财产品、投资项目等广告；</div>
    <div class="doc-text doc-pb28">12）法律、行政法规禁止的其他内容。</div>


    <div class="doc-text doc-font-bold">2、禁止发布违反证券和基金法律法规的信息以及非法证券投资咨询活动信息，包括但不限于以下内容：</div>

    <div class="doc-text">1）故意编造并散播影响证券、期货等交易或其他扰乱金融秩序的虚假信息；</div>
    <div class="doc-text">2）向用户直接推荐股票代码，提供股票直接买入卖出建议等；</div>
    <div class="doc-text">3）发布“非法荐股”等非法证券投资咨询活动信息；</div>
    <div class="doc-text">4）变相诱导用户到本社区以外的平台渠道（如微信，QQ等），向用户提供各种股票教程，推荐证券产品等；</div>
    <div class="doc-text">5）通过文章或评论，诱导用户到其他平台开通股票、期货等投资交易帐号；</div>
    <div class="doc-text">6）发布夸大不实的相关文章，向用户提供交易决策，并收取相关收益分成或费用；</div>
    <div class="doc-text">7）假冒相关合法证券机构，发布以营销为目的，提供非法证券投资咨询业务行为；</div>
    <div class="doc-text doc-pb28">8）根据法律法规、监管规定等认定的其他形式的非法证券投资咨询活动。</div>

    <div class="doc-text doc-font-bold">3、社区禁止的其他恶意违规行为及不良信息内容：</div>

    <div class="doc-text">1）冒充他人或机构、国家机关、上市企业或盈宝官方人员，通过头像及用户名等暗示自己与他人或机构相等同或有关联；</div>
    <div class="doc-text">2）注册的ID名称、头像或简介涉及政治性、侮辱性的；</div>
    <div class="doc-text">3）对社区其他用户进行蓄意人身攻击、谩骂、发布低俗不文明的言论行为；</div>
    <div class="doc-text">4）通过注册水军，以人工或机器人方式发布虚假内容、误导用户、炒作某类题材概念或个股、或干扰社区正常运作的行为；</div>
    <div class="doc-text">5）恶意泄露他人隐私，或者其他侵犯他人合法权益的行为；</div>
    <div class="doc-text">6）违规发布/诱导用户添加联系方式、下载第三方工具、加群、分享第三方链接等；</div>
    <div class="doc-text">7）留下任何联系方式、网址以及广告、QQ群、微信号、公众号、微博号等信息；</div>
    <div class="doc-text">8）发布各种推销、广告信息或其他任何形式的劝诱资料；</div>
    <div class="doc-text">9）通过不同方式发布或邀请用户参加任何非盈宝官方组织的第三方举办的线上或线下活动；</div>
    <div class="doc-text">10）使用夸张标题，发布与内容和标题严重不符的文章；</div>
    <div class="doc-text">11）其他影响社区正常运营的行为。</div>

    <div class="doc-main-title">二、社区违规处理</div>

    <div class="doc-text">1、根据用户发布的违法违规信息行为的次数、影响程度以及其他相关因素，盈宝社区将视情况决定采取限制展示、删除违规内容、账号禁言、关闭账号以及其他可行的处罚措施；</div>
    <div class="doc-text">2、盈宝社区在法律允许的最大范围内保留对本规则和相关罚则的解释权；</div>
    <div class="doc-text">3、盈宝社区可根据法制法规、社区建设和社区管理经验的丰富，出于维护盈宝社区氛围和发展的目的，不断完善本规则。</div>

    <div class="doc-main-title">三、免责声明及相关事项</div>

    <div class="doc-text">1、任何社区用户所发布的内容均系用户个人行为，并不反映任何本社区之意见，盈宝及本社区不为其承担任何法律责任；</div>
    <div class="doc-text">2、本社区只提供交流、讨论场所，社区用户发表的内容及言论仅代表其个人观点，不代表本社区立场，对于社区用户发表的内容及言论的真实性引发的全部责任，由社区用户自行承担，盈宝及本社区不承担任何责任；</div>
    <div class="doc-text">3、本社区有权转载或引用用户通过本社区发表的文章作品；</div>
    <div class="doc-text doc-pb28">4、本社区有权在必要时修改规则条款，本社区规则条款一旦发生变动，将会在重要页面上提示修改内容。如果不同意所改动的内容，用户可以主动取消获得的本社区信息服务。如果用户继续享用本社区信息服务，则视为接受规则条款的变动。本社区保留随时修改或中断服务而不需通知用户的权利。本社区行使修改或中断服务的权利，不需对用户或第三方负责。</div>

    <div class="doc-text">用户在本社区发表言论，等同于已阅读并接受以上规则。</div>
  </div>
`
